import type { ComponentType } from 'react';

import { components } from 'react-select';

type AnyComponent = ComponentType<any>;

export const reactSelectComponents = {
  ClearIndicator: components.ClearIndicator as AnyComponent,
  Control: components.Control as AnyComponent,
  DropdownIndicator: components.DropdownIndicator as AnyComponent,
  LoadingIndicator: components.LoadingIndicator as AnyComponent,
  LoadingMessage: components.LoadingMessage as AnyComponent,
  MultiValue: components.MultiValue as AnyComponent,
  MultiValueRemove: components.MultiValueRemove as AnyComponent,
  NoOptionsMessage: components.NoOptionsMessage as AnyComponent,
  Option: components.Option as AnyComponent,
};
